
import { Component, Prop, Vue } from "vue-property-decorator";

import * as _ from 'underscore';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import { form1DataInfoType, form1FormsJsonDataType } from "@/types/Information/Form1";

@Component
export default class TableForm1 extends Vue {

    @Prop({required: true})
    enableActions!: boolean;
    
    @form1State.State
    public form1FormsJson!: form1FormsJsonDataType[];
    
    @form1State.Action
    public UpdateCurrentNoticeOfAppealId!: (newCurrentNoticeOfAppealId: string) => void
    
    allDocumentsChecked = false;
    
    documentsList = [];
  
    documentsFields = [
        {
            key:'select',          
            label:'',                  
            thClass: 'border-dark border-bottom',            
            sortable:false            
        },       
        {
            key: "fileNumber",
            label: "App #",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "description",
            label: "Document Description",
            sortable: false,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "lowerCourtFileNo",
            label: "Lower Court File No.",
            sortable: false,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "referenceNumber",
            label: "Reference #",
            sortable: false,
            thClass: 'border-dark border-bottom',
        }, 
        {
            key: "modifiedDate",
            label: "Save On",
            sortable: true,
            thClass: 'border-dark border-bottom',
        }, 
        {
            key: "status",
            label: "Status",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "appealSubmissionDeadline",
            label: "Deadline to File and Serve",
            sortable: true,
            thClass: 'border-dark border-bottom',
        }, 
       
        {
            key: "packageNum",
            label: "eFiling #",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "action",
            label: "Action",
            sortable: false,
            thClass: 'border-dark border-bottom',
        }
    ];

    confirmDelete = false;
    applicationsToDelete = [];
    applicationsToDeleteIds = [];
    applicationsNotAllowedToDelete = [];

    errorMsg = "";
    errorMsgDismissCountDown = 0;
   

    mounted() {
        this.extractDocuments();       
    }

    public extractDocuments () {
        
        this.documentsList = [];
        let count=0;
        for (const docJson of this.form1FormsJson) {                
            const doc = {
                isChecked: false, 
                id:'',
                pdf_types:'', 
                fileNumber:'', 
                lowerCourtFileNo:'', 
                parties:'', 
                appNames: '', 
                resNames: '', 
                status:'', 
                modifiedDate:'', 
                packageNum:'',
                packageUrl:'',
                description:'',
                appealSubmissionDeadline:''
            };
            
            doc.fileNumber = String(++count);
            doc.id= String(docJson.id)
            doc.lowerCourtFileNo = docJson.data.lowerCourtFileNo;
            doc.status = docJson.status;
            doc.modifiedDate = docJson.modified;
            doc.description = "Notice of Appeal"
            doc.appealSubmissionDeadline = docJson.data.appealSubmissionDeadline;
            doc.pdf_types = docJson.pdf_types
            // doc.description = Vue.filter('get-submission-fullname')(docJson.description.split(','));
            doc.packageUrl = docJson.packageUrl;
            doc.packageNum = docJson.packageNumber;

            this.documentsList.push(doc);
        }
        
        if(!this.enableActions && this.documentsList.length>2){            
            this.documentsList = _.sortBy(this.documentsList, 'modifiedDate').reverse().splice(0,2)
        }     
    }

    public resumeApplication(fileInfo: form1DataInfoType) {
        const noticeId = fileInfo.id.toString()
        console.log(noticeId)
        this.UpdateCurrentNoticeOfAppealId(noticeId)       
        this.$router.push({name: "start-form1", params: {caseId: noticeId}});
        
    }


    public downloadDocument(fileNumber?) {
        const checkedFileIdsList = this.documentsList.filter(doc => {return doc.isChecked}).map(doc => doc.id)

        if(fileNumber || checkedFileIdsList.length>0){
            
            const filenum = fileNumber? fileNumber: '0';
            const pdf_filename = fileNumber? "Form.pdf":"Form.zip";

            let pdfIds = ''
            for(const fileId of checkedFileIdsList)
                pdfIds+= '&id='+fileId;

            if(fileNumber) pdfIds = ''

            const pdf_type = 'FORM';
            const url = '/form1/form-print/'+filenum+'/?pdf_type='+pdf_type+pdfIds;
            const options = {
                responseType: "blob",
                headers: {
                "Content-Type": "application/json",
                }
            }
            this.$http.get(url, options)
            .then(res => {
                const blob = res.data;
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.download = pdf_filename;
                link.click();
                setTimeout(() => URL.revokeObjectURL(link.href), 1000);
            },err => {
                          
                this.errorMsg = "PDF file has not been generated for the selected documents !"
                this.errorMsgDismissCountDown = 5;                
            });
        }
    }

    public navigateToEFilingHub(package_url) {
        window.open(package_url)
    }

    public createDocument() { 
        this.UpdateCurrentNoticeOfAppealId(null)
        this.$router.push({name: "checklist-form1" });
    }


    public deleteDocument() {

        this.applicationsToDelete = this.documentsList.filter(doc => {return (doc.isChecked && doc.status !='Submitted')}).map(doc => doc.fileNumber)
        this.applicationsToDeleteIds = this.documentsList.filter(doc => {return (doc.isChecked && doc.status !='Submitted')}).map(doc => doc.id)
        this.applicationsNotAllowedToDelete = this.documentsList.filter(doc => {return (doc.isChecked && doc.status =='Submitted')}).map(doc => doc.fileNumber)

        if(this.applicationsToDelete.length>0 || this.applicationsNotAllowedToDelete.length>0){
            this.confirmDelete=true;      
        }
    }


    public confirmDeleteApplication() { 
        
        const data ={
            data:{
                ids:this.applicationsToDeleteIds
            }
        }

        const url = '/form1/forms';

        this.$http.delete(url, data)
        .then(response => {
            
            if(response?.status == 204)
                this.$emit('reload')

        }, err => {
            this.errorMsg = "Error while Deleting !"
            this.errorMsgDismissCountDown = 2;
        })
        
        this.confirmDelete=false;

    }


    public checkAllDocuments(checked){
        for(const docInx in this.documentsList) {       
            this.documentsList[docInx].isChecked = checked;              
        }        
    }


    public toggleSelectedDocuments() {  
        Vue.nextTick(()=>{

            const checkedDocs = this.documentsList.filter(document=>{return document.isChecked});
            
            if(checkedDocs.length == this.documentsList.length)
                this.allDocumentsChecked = true;
            else
                this.allDocumentsChecked = false;                       
        })        
	}


    public errorMsgCountDownChanged(dismissCountDown){
        this.errorMsgDismissCountDown = dismissCountDown
    }
}
